<template>
  <div>
    <vuetify-google-autocomplete
      v-if="_isEmpty(label)"
      id="map"
      dense
      append-icon="search"
      classname="form-control"
      placeholder="Start typing an address"
      outlined
      :country="'ca'"
      v-on:placechanged="getAddressData"
    />
    <div v-if="!_isEmpty(label)">
      <v-icon @click="clear()">close</v-icon> {{ label }}
    </div>
  </div>
</template>
<script>
import { isEmpty, get } from 'lodash'

export default {
  props: {
    location: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      label: null,
      data: {}
    }
  },
  watch: {
    // label isnt updated by the time getAddressData is triggered
    // easy solution for the mean time
    label() {
      this.emit()
    }
  },
  mounted() {
    this.label = get(this.location, 'label', null)
  },
  methods: {
    _isEmpty: val => isEmpty(val),
    getAddressData(data, parsed) {
      if (data) {
        this.label = get(parsed, 'formatted_address')
        this.data = data
        this.emit()
      }
    },
    clear() {
      this.reset()
      this.emit()
    },
    emit() {
      const payload = {
        label: this.label,
        data: this.data
      }
      this.$emit('change-address', payload)
    },
    reset() {
      this.label = null
      this.data = {}
    }
  }
}
</script>
